import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col } from "reactstrap";
import Select from 'react-select'

// helpers
import { showMessage } from "helpers/message.js";

// api
import formulariovistoria_api from "../../../../api/formulariovistoria_api.js";
import indiceiqg_api from '../../../../api/indiceiqg_api';
import penalidade_api from '../../../../api/penalidade_api';

export default function FormularioFichaIdentificacao({ setshowLoading, isDisable, formularioVistoria, update }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    // Local Execução
    const options_localExecucao = [
        { label: "Aplicativo", value: "APP" },
        { label: "Sistema Web", value: "Web" }
    ];

    const [localExecucao, set_localExecucao] = useState(null);
    const handleChangeLocalExecucao = (value) => {
        set_localExecucao(value);
        clearErrors("localExecucao");
        setValue("localExecucao", value, true);
    }

    // Informar Regional
    const options_informarRegional = [
        { label: "Sim", value: true },
        { label: "Não", value: false }
    ];
    const [informarRegional, set_informarRegional] = useState(true);
    const handleChangeInformarRegional = (value) => {
        set_informarRegional(value);
        clearErrors("informarRegional");
        setValue("informarRegional", value, true);
    }

    // Requer Análise de Inconformidades
    const options_requerAnaliseDeInconformidades = [
        { label: "Sim", value: true },
        { label: "Não", value: false }
    ];
    const [requerAnaliseDeInconformidades, set_requerAnaliseDeInconformidades] = useState(false);
    const handleChangeRequerAnaliseDeInconformidades = (value) => {
        set_requerAnaliseDeInconformidades(value);
        clearErrors("requerAnaliseDeInconformidades");
        setValue("requerAnaliseDeInconformidades", value, true);
    }

    // Índices de IQG
    const [options_indicesIQG, set_options_indicesIQG] = useState([]);
    const loadOptionsIndicesIQG = () => {
        indiceiqg_api.getListaIndiceIQG().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _lista = [{ indiceIQG_Id: null, identificacao: "Nenhum" }, ...result.data];
                set_options_indicesIQG(_lista);
            }
        })
    }
    const [indiceIQG, set_indiceIQG] = useState(null);
    const handleChangeIndiceIQG = (value) => {
        setValue("indiceIQG", value);
        set_indiceIQG(value);
    }

    // Formulário Vinculado
    const [options_formularioVinculado, set_options_formularioVinculado] = useState([]);
    const loadOptionsFormularioVinculado = () => {
        formulariovistoria_api.getAll().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _lista = [{ formularioVistoria_Id: null, identificacao: "Nenhum" }, ...result.data];
                set_options_formularioVinculado(_lista);
                if (formularioVistoria && formularioVistoria.formularioVistoriaVinculado_Id) {
                    set_formularioVinculado(_lista.filter(f => f.formularioVistoria_Id == formularioVistoria.formularioVistoriaVinculado_Id)[0]);
                }
            }
        })
    }
    const [formularioVinculado, set_formularioVinculado] = useState(null);
    const handleChangeFormularioVinculado = (value) => {
        setValue("formularioVinculado", value);
        set_formularioVinculado(value);
    }

    const loadForm = () => {
        if (formularioVistoria) {
            setValue("identificacao", formularioVistoria.identificacao);
            set_indiceIQG(formularioVistoria.indiceIQG);
            set_localExecucao(formularioVistoria.localExecucao);
            setValue("localExecucao", formularioVistoria.localExecucao, true);
            setValue("informarRegional", formularioVistoria.informarRegional, true);
            set_informarRegional(formularioVistoria.informarRegional);
            setValue("requerAnaliseDeInconformidades", formularioVistoria.requerAnaliseDeInconformidades, true);
            set_requerAnaliseDeInconformidades(formularioVistoria.requerAnaliseDeInconformidades);
            setValue("totalInspecoesVistoria", formularioVistoria.totalInspecoesVistoria);
            setValue("totalInconformidadesPenalidade", formularioVistoria.totalInconformidadesPenalidade);
            setValue("totalFotosInspecao", formularioVistoria.totalFotosInspecao);
            set_penalidades(formularioVistoria.formularioVistoriaPenalidades);
        }
    }

    const [options_penalidades, set_options_penalidades] = useState([]);
    const loadPenalidades = () => {
        penalidade_api.GetPenalidadesAtivas().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                set_options_penalidades(result.data);
            }
        })
    }

    const [penalidades, set_penalidades] = useState([]);
    const handlePenalidades = (value) => {
        let _penalidades = [];
        value.map(p => _penalidades.push({
            penalidade_Id: p.penalidade_Id,
            clausulaContratual: p.clausulaContratual,
            descricao: p.descricao,
            status: p.status
        }));
        set_penalidades(_penalidades);
    }

    useEffect(() => {
        loadForm();
        loadOptionsIndicesIQG();
        loadOptionsFormularioVinculado();
        loadPenalidades();
    }, []);

    const onSubmit = (data) => {
        let json_submit = {
            formularioVistoria_Id: formularioVistoria ? formularioVistoria.formularioVistoria_Id : 0,
            identificacao: data.identificacao,
            indiceIQG_Id: indiceIQG ? indiceIQG.indiceIQG_Id : null,
            localExecucao: localExecucao,
            informarRegional: informarRegional,
            requerAnaliseDeInconformidades: requerAnaliseDeInconformidades,
            TotalInspecoesVistoria: data.totalInspecoesVistoria,
            TotalInconformidadesPenalidade: data.totalInconformidadesPenalidade,
            totalFotosInspecao: data.totalFotosInspecao,
            formularioVistoriaVinculado_Id: formularioVinculado ? formularioVinculado.formularioVistoria_Id : null,
            FormularioVistoriaPenalidades: penalidades
        }

        setshowLoading(true);
        if (json_submit.formularioVistoria_Id == 0)
            formulariovistoria_api.postFormularioVistoria(json_submit).then(result => handleReturnSubmit(result));
        else
            formulariovistoria_api.putFormularioVistoria(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                update(result.data);
            });
        }
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="align-items-end">
                    <Col lg="6" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Identificação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="identificacao"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Índice de IQG</label>
                            <Select
                                name="indiceIQG"
                                options={options_indicesIQG}
                                getOptionLabel={o => o.identificacao}
                                getOptionValue={o => o.indiceIQG_Id}
                                value={indiceIQG}
                                onChange={(o) => handleChangeIndiceIQG(o)}
                                classNamePrefix="select"
                                placeholder="Nenhum"
                                ref={e => register(
                                    { name: "" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Local de execução</label>
                            <Select
                                name="localExecucao"
                                options={options_localExecucao}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_localExecucao.filter(f => f.value == localExecucao)}
                                onChange={(o) => handleChangeLocalExecucao(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "localExecucao" },
                                    { required: true })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.localExecucao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Informar Regional</label>
                            <Select
                                name="informarRegional"
                                options={options_informarRegional}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_informarRegional.filter(f => f.value == informarRegional)}
                                onChange={(o) => handleChangeInformarRegional(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "informarRegional" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.informarRegional && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Requer Análise de Inconformidades</label>
                            <Select
                                name="requerAnaliseDeInconformidades"
                                options={options_requerAnaliseDeInconformidades}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_requerAnaliseDeInconformidades.filter(f => f.value == requerAnaliseDeInconformidades)}
                                onChange={(o) => handleChangeRequerAnaliseDeInconformidades(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "requerAnaliseDeInconformidades" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.requerAnaliseDeInconformidades && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="5" md="4" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Quantidade de inspeções necessárias para finalizar a vistoria</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="number"
                                name="totalInspecoesVistoria"
                                min="0"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.totalInspecoesVistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg={localExecucao !== "Web" ? 6 : 4} md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Quantidade de não conformidades para considerar penalidade</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="number"
                                name="totalInconformidadesPenalidade"
                                min="0"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.totalInconformidadesPenalidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg={localExecucao !== "Web" ? 6 : 4} md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Quantidade de fotos obrigatórias</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="number"
                                name="totalFotosInspecao"
                                min="0"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.totalFotosInspecao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="4" sm="12" className={localExecucao == "Web" ? "" : "d-none"}>
                        <FormGroup>
                            <label className="form-control-label">Formulário vinculado para análise das respostas</label>
                            <Select
                                name="formularioVinculado"
                                options={options_formularioVinculado}
                                getOptionLabel={o => o.identificacao}
                                getOptionValue={o => o.formularioVistoria_Id}
                                value={formularioVinculado}
                                onChange={(o) => handleChangeFormularioVinculado(o)}
                                classNamePrefix="select"
                                placeholder="Nenhum"
                                ref={e => register(
                                    { name: "" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">* Penalidades</label>
                            <Select
                                name="penalidades"
                                options={options_penalidades}
                                getOptionLabel={o => o.descricao}
                                getOptionValue={o => o.penalidade_Id}
                                value={options_penalidades.filter(({ penalidade_Id }) => penalidades.filter(f => f.penalidade_Id == penalidade_Id).length > 0)}
                                onChange={(o) => handlePenalidades(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                isMulti={true}
                                ref={e => register(
                                    { name: "penalidades" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.penalidades && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                </Row>
                {!isDisable &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="success" type="submit">
                                <i className="fas fa-save"></i>  Salvar
                            </Button>
                        </Col>
                    </Row>
                }
            </Form>
        </>
    );
}

